<template>
  <tr class="border-strokes border-t border-solid">
    <td class="p-2!">
      <div class="flex"><RfBaseSkeleton height="25" width="120" dynamic /></div>
    </td>
    <td class="p-2!">
      <div class="flex justify-end">
        <RfBaseSkeleton height="25" width="30" dynamic range="5" />
      </div>
    </td>
    <td v-if="!hideImpressions" class="p-2!">
      <div class="flex justify-end">
        <RfBaseSkeleton height="25" width="30" dynamic range="5" />
      </div>
    </td>
    <td class="p-2!">
      <div class="flex justify-end">
        <RfBaseSkeleton height="25" width="30" dynamic range="5" />
      </div>
    </td>
    <td class="p-2!">
      <div class="flex justify-end">
        <RfBaseSkeleton height="25" width="30" dynamic range="5" />
      </div>
    </td>
  </tr>
</template>

<script setup>
import RfBaseSkeleton from "@/components/skeletons/RfBaseSkeleton.vue";

defineProps({ hideImpressions: { type: Boolean, default: false } });
</script>
